import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import React from 'react';

import useCheckEligibility from '../../../components/checkEligibility/useCheckEligibility';
import useEnrollmentUrl from '../../../hooks/useEnrollmentUrl';
import Button from '../../../components/button/Button';
import DropdownInput from '../../../components/dropdownInput/DropdownInput';
import Location from '../../../assets/icons/location.svg';
import ModalType from '../../../models/ModalType';
import Shield from '../../../assets/icons/shield.svg';

import { useModal } from '../../../context/ModalContext';
import { InsurancesCarousel } from '../../../components/insurancesCarousel/InsurancesCarousel';

import './heroV3Section.scss';

export default function HeroV3Section(props) {
  const {
    title,
    subtitle,
    eligibilityTitle,
    button,
    backgroundUrl,
  } = props;

  const { openModal } = useModal();
  const { enrollmentUrl } = useEnrollmentUrl();

  const {
    inputState,
    setInputState,
    states,
    inputInsurance,
    setInputInsurance,
    handleCheckEligibility,
    insurances,
    stateSelected,
    insuranceSelected,
    isLoading,
  } = useCheckEligibility(false);

  async function checkEligibility() {
    const result = await handleCheckEligibility();
    openModal(ModalType.CHECK_ELIGIBILITY, { result });
  }

  return (
    <section className="hero-v3">
      <div className="hero-container">
        <div className="content-container">
          <div className="title-container">
            <h2>{parse(title)}</h2>
            <h6>{parse(subtitle)}</h6>
          </div>

          <div className="check-container">
            <p className="eligibility-title">{eligibilityTitle}</p>

            <div className="inputs-container">
              <DropdownInput
                value={inputState}
                valueChange={setInputState}
                placeholder="State you're insured in"
                icon={(<Location width="16px" height="16px" />)}
                dropdownList={states}
                idKey="code"
                displayedKey="name"
              />

              <DropdownInput
                value={inputInsurance}
                valueChange={setInputInsurance}
                placeholder="Insurance carrier & plan"
                icon={(<Shield width="16px" height="16px" />)}
                dropdownList={insurances}
                idKey="id"
                displayedKey="displayName"
              />

              <Button
                text={button}
                displayArrow
                dataAttr="CTA_clicked_hero"
                className="blue"
                disabled={!stateSelected() || !insuranceSelected()}
                loading={isLoading}
                onClick={() => checkEligibility()}
              />
            </div>

            <p>
              Paying out of pocket?
              {' '}
              <a href={enrollmentUrl}>Book now for a flat $149 rate</a>
            </p>
          </div>
        </div>

        <div className="image-container">
          <img
            // eslint-disable-next-line react/no-unknown-property
            fetchPriority="high"
            src={backgroundUrl}
            alt="home-background"
          />
        </div>
      </div>

      <div className="insurances-container">
        <InsurancesCarousel />
      </div>
    </section>
  );
}

HeroV3Section.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  eligibilityTitle: PropTypes.string.isRequired,
  button: PropTypes.string.isRequired,
  backgroundUrl: PropTypes.string.isRequired,
};
